import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ORGANIZATION_INSTRUCTION_TYPE_LIST = gql`
  query OrganizationInstructionTypeList(
    $filter: OrganizationInstructionTypeListFilter
  ) {
    organizationInstructionTypeList(filter: $filter)
  }
`;
